import { KontaxTransactionFilterOptions } from "../../../../types";

/**
 * The Verification View's filter state lives in two places: the filter bar
 * (`filterOptions`) and the column-header filters (component state). Both the
 * table request and the export request must be built from this one function, or
 * the downloaded file will silently not match what is on screen.
 */
export const buildRequestFilters = ({
  filterOptions,
  sort,
  assetsFilter,
  noteFilters,
  verifiedFilter,
  verifiedByMLFilter,
  submissionStatusFilter,
  currencyFilter,
}: {
  filterOptions: KontaxTransactionFilterOptions;
  sort?: { field: string; direction: string };
  assetsFilter?: boolean;
  noteFilters: { internalNote: boolean | null; personalNote: boolean | null };
  verifiedFilter?: boolean;
  verifiedByMLFilter?: boolean;
  submissionStatusFilter: string | null;
  currencyFilter?: string;
}): KontaxTransactionFilterOptions => ({
  ...filterOptions,
  ...(sort && { sort }),
  ...(assetsFilter !== undefined && { assets: assetsFilter }),
  ...(noteFilters.internalNote !== null && {
    internalNote: noteFilters.internalNote,
  }),
  ...(noteFilters.personalNote !== null && {
    personalNote: noteFilters.personalNote,
  }),
  ...(verifiedFilter !== undefined && { verified: verifiedFilter }),
  ...(verifiedByMLFilter !== undefined && { verifiedByML: verifiedByMLFilter }),
  ...(submissionStatusFilter !== null && {
    submissionStatus: submissionStatusFilter,
  }),
  ...(currencyFilter && { currency: currencyFilter }),
});
